import { selectForgetPasswordStep } from '../../store/forgetPassword/selectors';
import { setForgetPasswordStep } from '../../store/forgetPassword/slice';
import { useDispatch, useSelector } from '../../store/store';
import ResetPassword from './containers/ResetPassword';
import Entrance from '../../layouts/Entrance';
import Approval from './containers/Approval';
import Username from './containers/Username';
import Verify from './containers/Verify';
import { useEffect } from 'react';

const steps = {
    Username: <Username />,
    verify: <Verify />,
    ResetPassword: <ResetPassword />,
    Approval: <Approval />,
};

function ForgetPassword() {
    const step = useSelector(selectForgetPasswordStep);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(setForgetPasswordStep('Username'));
        }
    }, []);

    return (
        <Entrance>
            {steps[step]}
        </Entrance>
    )
}

export default ForgetPassword;
